/**
 * OP Progress Scales: TCMS includes derived score/interpretation (often 0),
 * so validate explicitly on item selections/comments.
 */
export const isTcmsScaleKey = (scaleKey) => {
  if (typeof scaleKey !== "string") return false;
  const k = scaleKey.trim().toLowerCase();
  return k === "trunkcontroltest" || k === "tcms" || k === "tcm" || k === "tcmscale";
};

export const hasTcmsAssessmentInput = (data) => {
  if (!data || typeof data !== "object") return false;

  if (String(data.comments ?? "").trim().length > 0) return true;

  for (const k of ["sitting_balance", "selective_movement_control", "sitting_to_standing"]) {
    const v = data[k];
    if (v == null || v === "") continue;
    const n = typeof v === "number" ? v : Number(v);
    // Default is 0; any >0 indicates user input.
    if (Number.isFinite(n) && n > 0) return true;
  }

  return false;
};

